<template>
  <div class="post-detail" v-if="Object.keys(posts).length">
    <div class="ly-card">
      <div class="hd">
        <div class="left">
          <img
            :src="posts.post_user_head_image ? `${baseUrl}/${posts.post_user_head_image}` : AVT"
            style="vertical-align: middle"
            alt="发帖人头像"
            Width="50"
          />
          <div class="time">
            <div>{{ posts.post_user_name || '无' }}</div>
            <div>{{ posts.post_time }}</div>
          </div>
        </div>
        <div class="right">
          <el-button type="primary" size="text" @click="open(posts,'first')">回复</el-button>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="del()">删除</el-dropdown-item>
              <el-dropdown-item v-if="posts.is_banned" @click.native="cancelBanned()">解封</el-dropdown-item>
              <el-dropdown-item v-else @click.native="banned()">封贴</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="hd-title">
        <svg-icon icon-class="official" v-if="posts.is_official" />
        <svg-icon icon-class="topping" v-if="posts.is_topping" />
        <svg-icon icon-class="essence" v-if="posts.is_essence" />
        <!-- <strong>{{ posts.title }}</strong> -->
      </div>
      <div class="content" v-html="posts.content"></div>
      <div class="img-group">
        <div class="item" v-for="item in posts.attach_url" :key="item">
          <img v-if="isImage" :src="`${baseUrl}/${item}`" width="200px" />
          <video v-else :src="`${baseUrl}/${item}`" controls="controls" width="200px"></video>
        </div>
      </div>
    </div>
    <div class="reply ly-card">
      <div v-for="item in postsRep" :key="item.id">
        <div class="item m-b-10">
          <div class="avt m-r-10">
            <img
              width="25"
              style="vertical-align: middle"
              :src="item.reply_user_head_image ? `${baseUrl}/${item.reply_user_head_image}` : AVT"
              alt=""
            />
          </div>
          <div class="right">
            <div class="hd">
              <div>
                <div>{{ item.reply_user_name }}</div>
                <div class="time">{{ item.reply_time }}</div>
              </div>
              <div>
                <el-button v-if="item.reply_user_id===-2" type="primary" size="text" @click="openEdit(item)">修改</el-button>
                <el-button type="primary" size="text" @click="open(item,'other')">回复</el-button>
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i> </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="delReply(item)">删除</el-dropdown-item>
                    <el-dropdown-item v-if="item.is_banned" @click.native="cancelBannedReply(item)">解封</el-dropdown-item>
                    <el-dropdown-item v-else @click.native="bannedReply(item)">封贴</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                  <i class="el-icon-star-off"> {{item.like_count}}</i>

                </div>
            </div>
            <div class="m-t-10">
              {{ item.content }}
              </div>
          </div>
        </div>
        <div v-if="item.second_level_reply_list" :key="item.id" style="background:#f1f1f1;margin-left: 30px;">
          <div class="item m-b-10 m-l-20" v-for="subitem in item.second_level_reply_list" :key="subitem.id">
             <div class="avt m-r-10">
              <img
                width="25"
                style="vertical-align: middle"
                :src="subitem.reply_user_head_image ? `${baseUrl}/${subitem.reply_user_head_image}` : AVT"
                alt=""
              />
            </div>
            <div class="right">
              <div class="hd">
                <div>
                  <div>{{ subitem.reply_user_name }}</div>
                  <div class="time">{{ subitem.reply_time }}</div>
                </div>
                <div>
                   <el-button v-if="subitem.reply_user_id===-2" type="primary" size="text" @click="openEdit(subitem)">修改</el-button>
                  <el-button type="primary" size="text" @click="open(item,'other',subitem)">回复</el-button>
                  <el-dropdown trigger="click">
                    <span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i> </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="delReply(subitem)">删除</el-dropdown-item>
                      <el-dropdown-item v-if="subitem.is_banned" @click.native="cancelBannedReply(subitem)">解封</el-dropdown-item>
                      <el-dropdown-item v-else @click.native="bannedReply(subitem)">封贴</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <i class="el-icon-star-off"> {{subitem.like_count}}</i>
                </div>
              </div>
              <div class="m-t-10">
                <span v-if="item.id!==subitem.reply_to_reply_id">回复<em style='color:#4caf50;font-style:normal'>{{subitem.reply_to_user_name}}</em>：</span>
                {{subitem.content}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- {{this.getReplyDetail(postsRep)}} -->
      <el-pagination
        background
        layout="prev, pager, next"
        :total="page.total"
        :page-size="page.page_size"
        :current-page="page.page_no"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="sendType==='edit'?'修改回复':'官方回复'"
      :visible.sync="dialogVisible"
      width="600px"
      @close="close"
    >
      <div class="back-content ly-card">
        <div class="item m-r-10">
          <img :src="AVT" alt="官方头像" Width="50px" />
        </div>
        <el-input placeholder="官方回帖" rows="3" type="textarea" v-model="replyForm.content"></el-input>
      </div>
      <el-button type="primary" size="medium" @click="reply">发送</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem, Pagination, Input, Dialog } from 'element-ui';
import cPosts from '@/api/cPosts';
import cSetting from '@/api/cSetting';
import AVT from '@/assets/images/avt.png';
import pattern from '@/utils/pattern';

export default {
  name: 'PostsDetail',
  components: {
    ElDropdown: Dropdown,
    ElDropdownItem: DropdownItem,
    ElDropdownMenu: DropdownMenu,
    ElPagination: Pagination,
    ElInput: Input,
    ElDialog: Dialog
  },
  data() {
    return {
      AVT,
      posts: {
        attach_url: []
      },
      postsRep: {},
      page: {
        page_size: 10,
        page_no: 1,
        total: 0
      },
      actionType: {
        def: false,
        action: cSetting.cUpload
      },
      baseUrl: '',
      dialogVisible: false,
      replyForm: {
        post_id: this.$route.params.id,
        content: '',
        reply_to_reply_id: '',
        reply_to_user_name: '',
        parent_id: '',
        id: ''
      },
      sendType: ''
    };
  },
  async mounted() {
    this.init();
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
  },
  computed: {
    isImage() {
      return this.posts.attach_url.length ? pattern.IS_IMAGE.test(this.posts.attach_url[0]) : false;
    }
  },
  methods: {
    openEdit(data) {
      this.replyForm.content = data.content;
      this.replyForm.id = data.id;
      this.sendType = 'edit';
      this.dialogVisible = true;
    },
    open(data, type, subdata) {
      this.replyForm.content = '';
      this.sendType = 'add';
      if (type === 'other') {
        if (!subdata) {
          this.replyForm.reply_to_reply_id = data.id;
          this.replyForm.reply_to_user_name = data.reply_user_name;
        } else {
          this.replyForm.reply_to_reply_id = subdata.id;
          this.replyForm.reply_to_user_name = subdata.reply_user_name;
        }
        this.replyForm.parent_id = data.id;
      } else {
        this.replyForm.parent_id = '-1';
      }
      this.dialogVisible = true;
    },
    close() {
      this.content = '';
      this.sendType = '';
    },
    init() {
      this.getPostDetail();
      this.getReplyList();
    },
    getPostDetail() {
      cPosts
        .controlPosts({
          post_id: this.$route.params.id
        })
        .then(res => {
          if (res) {
            this.posts = res.data;
          }
        });
    },
    getReplyList() {
      cPosts
        .replyList({
          params: {
            post_id: this.$route.params.id,
            ...this.page
          }
        })
        .then(res => {
          if (res && res.data) {
            this.postsRep = res.data.list;
            this.page = {
              page_no: res.data.page_no,
              page_size: res.data.page_size,
              total: res.data.total
            };
          }
        });
    },
    reply() {
      if (this.sendType === 'edit') {
        cPosts.editReply({
          params: { content: this.replyForm.content },
          reply_id: this.replyForm.id
        }).then(res => {
          if (res) {
            this.$message.success(res.msg || '修改成功！');
            this.replyForm.content = '';
            this.sendType = '';
            this.getReplyList();
            this.dialogVisible = false;
          }
        });
      } else {
        const temp = { ...this.replyForm };
        if (temp.parent_id === '-1') {
          delete temp.reply_to_reply_id;
          delete temp.reply_to_user_name;
          delete temp.parent_id;
        }
        cPosts
          .reply({
            params: { ...temp }
          })
          .then(res => {
            if (res) {
              this.$message.success(res.msg || '回帖成功！');
              this.replyForm.content = '';
              this.sendType = '';
              this.getReplyList();
              this.dialogVisible = false;
            }
          });
      }
    },
    banned() {
      cPosts
        .bannedPosts({
          post_id: this.posts.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '封贴成功！');
            this.getPostDetail();
          }
        });
    },
    cancelBanned() {
      cPosts
        .unblockPosts({
          post_id: this.posts.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '取消封贴成功！');
            this.getPostDetail();
          }
        });
    },
    del() {
      this.$confirm('确认删除该帖子？', '提示', {
        type: 'warning'
      })
        .then(() => {
          cPosts
            .controlPosts({
              post_id: this.posts.id,
              params: {
                category_id: this.posts.category_id
              },
              methold: 'delete'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功');
                this.$router.push(`/${this.$route.params.user_id}/community/content`);
              }
            });
        })
        .catch(() => {});
    },
    pageChange(page_no) {
      this.page.page_no = page_no;
      this.getReplyList();
    },
    delReply(item) {
      this.$confirm('确认删除该回帖？', '提示', {
        type: 'warning'
      })
        .then(() => {
          cPosts
            .delReply({
              reply_id: item.id,
              params: {
                post_id: this.posts.id
              },
              methold: 'delete'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功');
                this.getReplyList();
              }
            });
        })
        .catch(() => {});
    },
    bannedReply(item) {
      cPosts
        .bannedReply({
          reply_id: item.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '封贴成功！');
            this.getReplyList();
          }
        });
    },
    cancelBannedReply(item) {
      cPosts
        .unblockReply({
          reply_id: item.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '取消封贴成功！');
            this.getReplyList();
          }
        });
    }
  }
};
</script>

<style lang="less">
.post-detail {
  .hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      .time {
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        height: 50px;
      }
    }
  }
  .hd-title {
    font-size: 15px;
    margin: 10px 0;
    svg {
      vertical-align: top;
      margin-right: 5px;
      fill: @main-blue;
      width: 20px;
      height: 20px;
    }
  }
  .img-group {
    display: flex;
    margin-top: 20px;
    .item {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
  .back-content {
    display: flex;
    .item {
      display: flex;
      align-items: center;
    }
  }
  .reply {
    .item {
      display: flex;
      border-bottom: 1px solid #ccc;
      padding: 5px 0;
      .right {
        flex: 1;
        .hd {
          display: flex;
          justify-content: space-between;
        }
      }
      .time {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
  .el-icon-arrow-down {
    cursor: pointer;
  }
  .el-dialog__body{
    text-align: right;
  }
  .el-icon-star-off{
    display: block;
  }
}
</style>
